import React, { useEffect, useState } from 'react';
import Dropdown from '../Dropdown';
import { useSelector } from 'react-redux';
import { IRootState } from '../../../../Storage/Redux/store';
import { IconDashboard } from '@tabler/icons-react';
import { IconPlus, IconTrash } from '../../../Icon';
import { ItemInterface, ReactSortable } from 'react-sortablejs';
import { useDispatch } from 'react-redux';
import { setDashboardMenuOrder } from '../../../../Storage/Redux/slice/dashboardSlice';
import { SD_AccessLocalStorage } from '../../../../Utility/StaticDatas';
import { useGetDashboardCardListDropdownQuery } from '../../../../Apis/Common/SPCommonServicesApi';
import { convertData, rtkErrorRead } from '../../../../Helper';
import { SelectOption } from '../../../../Interfaces/PIMs';

const DashboardSetUp = () => {
  const isRtl =
    useSelector((state: IRootState) => state.themeConfig.rtlClass) === 'rtl'
      ? true
      : false;
  const dispatch = useDispatch();
  const { menuOrder } = useSelector(
    (state: IRootState) => state.dashboardSlice
  );

  const [availableItems, setAvailableItems] = useState<
    { id: number; value: string }[]
  >([]);

  const getDashboardCardListDropdown =
    useGetDashboardCardListDropdownQuery(null);

  useEffect(() => {
    if (getDashboardCardListDropdown.isError) {
      rtkErrorRead(getDashboardCardListDropdown.error);
    } else {
      const dbData: SelectOption[] = convertData(
        getDashboardCardListDropdown.data?.result
      );
      if (dbData) {
        setAvailableItems(
          dbData.map((x) => ({ id: Number(x.value), value: String(x.label) }))
        );
      }
    }
  }, [getDashboardCardListDropdown]);

  const handleItemSelect = (
    item: { id: number; value: string },
    event: React.MouseEvent
  ) => {
    event.stopPropagation();
    const updateItems = [...menuOrder];

    updateItems.push({
      id: item.id,
      value: item.value,
    });

    localStorage.setItem(
      SD_AccessLocalStorage.DashboardMenuOrder,
      JSON.stringify(updateItems)
    );
    dispatch(setDashboardMenuOrder(updateItems));
  };

  const handleItemRemove = (item: string, event: React.MouseEvent) => {
    event.stopPropagation();
    const updateItems = menuOrder.filter(
      (selectedItem) => selectedItem.value !== item
    );
    dispatch(setDashboardMenuOrder(updateItems));
    localStorage.setItem(
      SD_AccessLocalStorage.DashboardMenuOrder,
      JSON.stringify(updateItems)
    );
  };

  const resetDashboardMenu = () => {
    if (availableItems.length > 0) {
      localStorage.setItem(
        SD_AccessLocalStorage.DashboardMenuOrder,
        JSON.stringify(availableItems)
      );
      dispatch(setDashboardMenuOrder(availableItems));
    }
  };

  return (
    <div className="dropdown shrink-0">
      <Dropdown
        offset={[0, 8]}
        placement={`${isRtl ? 'bottom-start' : 'bottom-end'}`}
        btnClassName="relative flex h-9 w-9 items-center justify-center rounded-full border border-black/10 dark:border-white/10 bg-white-light/40 dark:bg-dark/40 hover:text-primary hover:bg-white-light/90 dark:hover:bg-dark/60 transition-colors"
        button={
          <span className="flex items-center justify-center">
            <IconDashboard />
          </span>
        }
      >
        <ul
          onClick={(e) => e.stopPropagation()}
          className="!py-0 text-dark dark:text-white-dark w-[300px] sm:w-[850px] divide-y dark:divide-white/10"
        >
          <li>
            <div className="flex">
              <div className="w-1/2 p-4 border-r dark:border-white/20">
                <h3 className="text-lg font-semibold">Available Items</h3>
                <ul className="space-y-2">
                  {availableItems.map(
                    (item) =>
                      !menuOrder.some((s) => s.value === item.value) && (
                        <li
                          key={item.value}
                          className="cursor-pointer text-sm text-dark dark:text-white-dark hover:text-primary px-4 py-2 flex justify-between"
                        >
                          <span>{item.value}</span>
                          <span onClick={(e) => handleItemSelect(item, e)}>
                            <IconPlus className="text-success" />
                          </span>
                        </li>
                      )
                  )}
                </ul>
              </div>

              <div className="w-1/2 p-4 shadow-none">
                <div className="flex gap-3">
                  <h3 className="text-lg font-semibold">Selected Items</h3>
                  <button
                    onClick={resetDashboardMenu}
                    className="btn btn-sm btn-primary"
                  >
                    Reset
                  </button>
                </div>
                <ol className="space-y-2 shadow-none! mt-3">
                  <ReactSortable
                    list={menuOrder.map((item) => ({ ...item }))}
                    setList={(x) => {
                      dispatch(setDashboardMenuOrder(x));
                      localStorage.setItem(
                        SD_AccessLocalStorage.DashboardMenuOrder,
                        JSON.stringify(x)
                      );
                    }}
                  >
                    {menuOrder.map((item, ind) => (
                      <li
                        key={ind}
                        className="cursor-grab text-sm text-dark dark:text-white-dark hover:text-primary px-4 py-3 flex justify-between border shadow-sm rounded-lg dark:bg-slate-900 dark:border-0 mt-2"
                      >
                        <span>{item.value}</span>
                        {menuOrder.length !== 1 && (
                          <span
                            className="cursor-pointer"
                            onClick={(e) => handleItemRemove(item.value, e)}
                          >
                            <IconTrash className="text-danger" />
                          </span>
                        )}
                      </li>
                    ))}
                  </ReactSortable>
                </ol>
              </div>
            </div>
          </li>
        </ul>
      </Dropdown>
    </div>
  );
};

export default DashboardSetUp;
